module.exports = __webpack_public_path__ + "img/FHWP_mace.370f314d.png";